var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C43B4D",
    fillRule: "evenodd",
    d: "M1.232 28.462C2.875 30 9.447 30 12.733 31.538c3.287 1.539 5.116 2.552 9.859 6.154C26.224 40.452 27.52 50 32.45 50c4.467 0 4.467-6.154 0-18.462h11.5c1.644 0 4.93-4.615 1.644-9.147 1.334-1.908 1.643-4.699-.264-8.722.901-1.735.264-5.207-1.56-7.228.12-2.755-.914-4.646-3.105-5.672-7.668-1.025-13.692-1.025-18.073 0C16.02 2.308 2.875 3.947 1.232 5.485c-1.643 1.539-1.643 21.438 0 22.977z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.bba3b59ae3501bc03151125e565590c1.svg";
export { ForwardRef as ReactComponent };